enum AddressVersionEnum {
    V1 = 'V1',
    V2 = 'V2',
}

export default AddressVersionEnum;
